import { useCustomProp } from '@common/components/LibraryComponent/customProp';
import Loading from '@common/components/Loading';
import { defaultPathComponent } from '@common/constants/shared';
import {
  setDefaultValueInput,
  setValueInput,
} from '@common/redux/slice/formInputs';
import { ILibraryComponent } from '@common/types/element';
import { getValueBindingComponent } from '@common/utils/component';
import { get } from 'lodash';
import React, { FC, useCallback, useMemo } from 'react';
import { View } from 'react-native';
import { useDispatch, useSelector } from 'react-redux';

import createStyles from './style';
import { appInfoSelector } from '@common/redux/selectors/app';
import { AppVersion, Platform } from 'click-types';

declare global {
  interface Window {
    [key: string]: any;
  }
}

const CusLibraryComponent: FC<ILibraryComponent> = (attributes) => {
  const app = useSelector(appInfoSelector);

  const libraries =
    app?.version === AppVersion.V4
      ? require('@nocode/components/v4')
      : require('@nocode/components');

  const Component = libraries[attributes.componentName];

  const styles = createStyles(attributes);
  const { getCustomProp, loading } = useCustomProp(attributes);
  const dispatch = useDispatch();
  const valueInputs = useMemo(
    () => get(attributes?.dependencies?.valueInputs, attributes.id, false),
    [attributes.dependencies, attributes.id]
  );

  const changeInput = useCallback(
    (value: any) => {
      dispatch(
        setValueInput({
          [attributes.id]: value,
        })
      );
    },
    [attributes.id]
  );

  const setDefaultValue = useCallback(
    (value: any) => {
      dispatch(
        setDefaultValueInput({
          [attributes.id]: value,
        })
      );
    },
    [attributes.id]
  );

  if (loading) {
    return <Loading />;
  }

  if (!Component) return <></>;

  if (
    app?.version === AppVersion.V4 &&
    attributes.style?.position === 'fixed'
  ) {
    return (
      <Component
        {...attributes}
        {...getCustomProp()}
        valueInputs={valueInputs}
        changeInput={changeInput}
        setDefaultValue={setDefaultValue}
      >
        {attributes?.children}
      </Component>
    );
  }

  return (
    <View
      style={styles.container}
      nativeID={`library-component-wrapper-${attributes.componentName}-${attributes.id}`}
    >
      <Component
        {...attributes}
        {...getCustomProp()}
        valueInputs={valueInputs}
        changeInput={changeInput}
        setDefaultValue={setDefaultValue}
      >
        {attributes?.children}
      </Component>
    </View>
  );
};

export default CusLibraryComponent;
